import { Link } from 'react-router-dom';
import { teachingSteps } from '@/mocks/philosophyData';
import { useTranslation } from 'react-i18next';

export default function TeachingProcess() {
  const { t } = useTranslation();
  const stepKeys = [
    { num: 'philosophy.process.step1.num', title: 'philosophy.process.step1.title', desc: 'philosophy.process.step1.desc', step: teachingSteps[0].step },
    { num: 'philosophy.process.step2.num', title: 'philosophy.process.step2.title', desc: 'philosophy.process.step2.desc', step: teachingSteps[1].step },
    { num: 'philosophy.process.step3.num', title: 'philosophy.process.step3.title', desc: 'philosophy.process.step3.desc', step: teachingSteps[2].step },
    { num: 'philosophy.process.step4.num', title: 'philosophy.process.step4.title', desc: 'philosophy.process.step4.desc', step: teachingSteps[3].step },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            HOW WE TEACH
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('philosophy.process.title')}
          </h2>
          {String(t('philosophy.process.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('philosophy.process.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="relative">
          {/* Horizontal cycle on desktop, vertical on mobile */}
          <div className="hidden md:flex items-start justify-center gap-0">
            {stepKeys.map((step, idx) => (
              <div key={idx} className="flex items-start">
                <div className="flex flex-col items-center text-center max-w-[200px] px-4">
                  <div className="w-[72px] h-[72px] rounded-full bg-primary-900 border-2 border-accent-500/40 flex items-center justify-center mb-4">
                    <span className="font-heading text-xl text-accent-400 tracking-[0.06em]">{step.step}</span>
                  </div>
                  <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.06em] mb-2">
                    {t(step.title)}
                  </h3>
                  {String(t(step.desc)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
                </div>
                {idx < stepKeys.length - 1 && (
                  <div className="flex items-center pt-[36px] -ml-1">
                    <div className="w-10 h-[1px] bg-accent-500/30"></div>
                    <div className="w-0 h-0 border-t-[5px] border-t-transparent border-b-[5px] border-b-transparent border-l-[7px] border-l-accent-500/30"></div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Vertical on mobile */}
          <div className="md:hidden space-y-5">
            {stepKeys.map((step, idx) => (
              <div key={idx} className="flex items-start gap-4">
                <div className="w-[56px] h-[56px] rounded-full bg-primary-900 border-2 border-accent-500/40 flex items-center justify-center flex-shrink-0">
                  <span className="font-heading text-lg text-accent-400 tracking-[0.06em]">{step.step}</span>
                </div>
                <div>
                  <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.06em] mb-1.5">
                    {t(step.title)}
                  </h3>
                  {String(t(step.desc)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
                </div>
                {idx < stepKeys.length - 1 && (
                  <div className="hidden">separator</div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12 pt-8 border-t border-background-200/60">
          {String(t('philosophy.process.certNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-4">{__s}</p>))}
          <Link
            to="/certificate"
            className="inline-flex items-center gap-2 text-[15px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors"
          >
            {t('philosophy.process.certLink')}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
